// eslint-disable-next-line import/order
import React, { ReactNode, createContext, useContext, useState } from 'react';

import { CreateTaskOptions } from './create-drawer';

type TaskDrawerContextProps = {
  createOptions?: CreateTaskOptions | undefined;
  openCreate: (options?: CreateTaskOptions) => void;
  closeCreate: () => void;
};

export const TaskDrawerContext = createContext<TaskDrawerContextProps>({
  openCreate: () => {},
  closeCreate: () => {},
});

export const useTaskDrawer = () => {
  const taskDrawer = useContext(TaskDrawerContext);

  return taskDrawer;
};

export const TaskDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [createTaskOptions, setCreateTaskOptions] =
    useState<CreateTaskOptions>();

  return (
    <TaskDrawerContext.Provider
      value={{
        createOptions: createTaskOptions,
        openCreate: (opts) => setCreateTaskOptions(opts ?? {}),
        closeCreate: () => setCreateTaskOptions(undefined),
      }}
    >
      {children}
    </TaskDrawerContext.Provider>
  );
};
